import hero from './ztss-hero.jpg';
import valuePropForm from './ztss-vp-form.svg';
import valuePropMagnify from './ztss-vp-magnify.svg';
import valuePropPiggyBank from './ztss-vp-piggy-bank.svg';
import noPhotoForProperty from './ztss-property-no-photo.png';

export default {
  hero,
  valuePropForm,
  valuePropMagnify,
  valuePropPiggyBank,
  noPhotoForProperty,
};
